import { FC, useMemo } from "react";
import classNames from "classnames";
import { NotificationAPI } from "rc-notification";
import { INoticeEvent, INoticeEventVariant } from "contexts";
import { Svg } from "components/base/svg/Svg";
import { AssetsDirectory } from "@finbackoffice/enums";
import Button from "../button/Button";
import Translate from "../translate/Translate";
import styles from "./site-notification.module.sass";

export type ISiteNotificationVariant = "default" | "modal";
export interface ISiteNotificationProps extends INoticeEvent {
    wrapperClassname?: string;
    variant?: INoticeEventVariant;
    instance?: NotificationAPI;
    showIcon?: boolean;
}

const SiteNotification: FC<ISiteNotificationProps> = ({
    type,
    title,
    message,
    variant = "default",
    instance,
    wrapperClassname,
    showIcon = true,
}) => {
    const renderContent = useMemo(() => {
        if (variant === "modal") {
            return (
                <>
                    <div className={styles.modalTitle}>{title}</div>
                    <Translate text={message} dangerous>
                        <p className={styles.modalText} />
                    </Translate>
                    <Button
                        type="button"
                        variant="primary"
                        onClick={() => instance?.close(title)}
                        className={styles.modalButton}>
                        <Translate tid="base_close" />
                    </Button>
                </>
            );
        }
        return (
            <div className={classNames(styles.notification, styles[type], wrapperClassname)}>
                {title && (
                    <h3>
                        {showIcon && (
                            <Svg
                                src={`/${AssetsDirectory.Common}/${AssetsDirectory.Mobile}/${AssetsDirectory.BaseIcons}/notification-${type}.svg`}
                                className="svg-icon"
                            />
                        )}
                        {title}
                    </h3>
                )}
                {message && <span>{message}</span>}
            </div>
        );
    }, [instance, message, showIcon, title, type, variant, wrapperClassname]);

    return renderContent;
};

export default SiteNotification;
